/**
 * Shared utility for submitting forms via Web3Forms
 */
export async function submitToWeb3Forms(data, options = {}) {
    const {
        from_name = "Lexceed Website",
        subject = "New Form Submission",
        access_key = options.access_key || process.env.REACT_APP_WEB3FORMS_KEY
    } = options;

    console.log("[Web3Forms] Attempting submission with:", { from_name, subject, hasKey: !!access_key });
    console.log("[Web3Forms] Data:", data);

    if (!access_key) {
        console.error("[Web3Forms] Access Key is missing! Check your .env file and restart dev server.");
        throw new Error("Web3Forms Access Key is missing. Please check your .env file and RESTART your development server.");
    }

    const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            access_key,
            from_name,
            subject,
            ...data
        }),
    });

    const result = await response.json();

    if (!result.success) {
        throw new Error(result.message || "Form submission failed");
    }

    return result;
}
